import { app } from '../../../app';
import { Controller } from './data-deletion-form.controller';

app.component('dataDeletionForm', {
    templateUrl: require('./data-deletion-form.html'),
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/public/data-deletion-form/data-deletion-form.component.js